export const OPBooleanOptions = [
    { value: 'true', label: "Yes" },
    { value: 'false', label: "No" },
];

export const OPSchoolTypes = [
    { value: "corporation", label: "Corporation" },
    { value: "non-profit", label: "Non-profit" },
    { value: "unincorporated", label: "Unincorporated" },
    { value: "partnership", label: "Partnership" },
];

export const OPSchoolsStatuses = [
    { value: "setup", label: "Setup" },
    { value: "trial", label: "Trial" },
    { value: "active", label: "Active" },
    { value: "disabled", label: "Disabled" },
];

export const OPUserRoles = [
    { value: "admin", label: "Admin" },
    { value: "staff", label: "Staff" },
];

export const OPUserStatuses = [
    { value: "active", label: "Active" },
    { value: "disabled", label: "Disabled" },
];